// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"af4997b9","268":"d4720c94"}[chunkId] + ".chunk.css";
};